import { isNil } from "lodash/fp"
import {
    CognitoUserPool,
    type CognitoUserSession
} from 'amazon-cognito-identity-js'
import log from "loglevel"
import cognito from "./cognito.json"
import { httpRequest } from "../../functions/common"
import { AxiosHeaders, Method, RawAxiosRequestHeaders } from "axios"
import { inspect } from "./inspect"
const env = process.env['REACT_APP_ENV'] ?? 'dev'

const baseName = 'miraiz-connect.jp'
const zoneName = `${{ prd: '', stg: '', int: 'dev.', dev: 'dev.', exp: 'dev.' }[env] as string
    }${baseName}`
export const domainName = `api${{ prd: '', stg: '-stg', int: '-int', dev: '', exp: '-exp' }[env] as string
    }.bpo.${zoneName}`

const { userPoolId: UserPoolId, clientId: ClientId } =
    cognito[env as keyof typeof cognito]
const userPool = new CognitoUserPool({
    UserPoolId,
    ClientId
})
export const getCustomHeaders = (
): Headers | undefined => {
    const cognitoUser = userPool.getCurrentUser()
    if (isNil(cognitoUser)) return undefined
    let session: any
    cognitoUser.getSession(
        (error: Error, newSession: CognitoUserSession | null) => {
            if (!isNil(error)) {
                log.error('[DataProvider.fetchJson]', { error })
                return
            }
            session = newSession
        }
    )
    if (isNil(session)) return undefined
    const customHeaders = new Headers({
        Accept: 'application/json'
    }) as Headers
    customHeaders.set('Authorization', session.getIdToken().getJwtToken())
    return customHeaders
}

export const bpoApiRequest = async (
    method: Method,
    url: string,
    body?: any,
    headers?: RawAxiosRequestHeaders | AxiosHeaders,
    params?: any
): Promise<{ status: number; data: any } | undefined> => {
    const customHeaders = getCustomHeaders() as AxiosHeaders | undefined
    if (isNil(customHeaders)) {
        return undefined
    }
    const result = await httpRequest(method, `https://${domainName}${url}`,
        body,
        {
            ...headers,
            Authorization: customHeaders.get('Authorization')
        },
        params
    )
    if (isNil(result)) {
        return undefined
    }
    if (result.status === 500) {
        log.error('[functions.bpoApiRequest]', inspect({ result }))
    }
    return result
}